import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';


import * as styleUtils from '../../../../utils/styleUtils';

import Number from '../../Numeric/Number';

import styles from './Slider.scss';


function Slider({doShowMarks, isDisabled, max, min, onChange, step, thumbValueRenderer, value}) {

    let marks = [];
    if (doShowMarks) {
        marks = useMemo(() => {

            const marks = [];
            for (let mark = min + step; mark < max; mark += step) {
                marks.push(mark);
            }

            return marks;
        }, [doShowMarks, min, max, step]);
    }

    const steps = useMemo(() => {

        const steps = [];
        for (let stepValue = min; stepValue <= max; stepValue += step) {
            steps.push(stepValue);
        }

        return steps;
    }, [min, max, step]);

    const thumbRenderer = (props, {index, valueNow}) => {

        const isFirst = valueNow === min;
        const isLast = valueNow === max;
        const stepIndex = steps.indexOf(valueNow);

        return (
            <div {...props}>
                <div className={styleUtils.toClasses(styles.thumbLabel, isLast ? styles.last : null)}>
                    <span>
                        {thumbValueRenderer(valueNow, {index, isFirst, isLast, stepIndex})}
                    </span>
                </div>
            </div>
        );
    };

    return (
        <ReactSlider
            className={styles.slider}
            disabled={isDisabled}
            marks={marks}
            max={max}
            min={min}
            onAfterChange={onChange}
            renderThumb={thumbRenderer}
            step={step}
            value={value}
        />
    );
}


Slider.propTypes = {
    doShowMarks: PropTypes.bool,
    isDisabled: PropTypes.bool,
    max: PropTypes.number,
    min: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    step: PropTypes.number,
    thumbValueRenderer: PropTypes.func,
    value: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.number),
        PropTypes.number
    ])
};

Slider.defaultProps = {
    doShowMarks: false,
    isDisabled: false,
    min: 0,
    step: 1,
    thumbValueRenderer: value => <Number value={value}/>,
    value: 0
};


export default Slider;
